import _ from 'lodash'

const isLoading = (state) => _.get(state, 'loading')

const notes = (state) => _.get(state, 'notes')
const bookmarks = (state) => _.get(state, 'bookmarks')

const notesMeta = (state) => _.get(state, 'notesMeta')
const bookmarksMeta = (state) => _.get(state, 'bookmarksMeta')

const editableNote = (state) => _.get(state, 'editableNote')

const profileErrors = (state) => _.get(state, 'errors')

export default {
	isLoading,
	notes,
	bookmarks,
	notesMeta,
	bookmarksMeta,
	editableNote,
	profileErrors
}
